import { ADICIONAR_FILTRO_ENCOMENDA } from '../types'

export default function adicionarFiltroEncomenda (filtro) {
  return {
    type: ADICIONAR_FILTRO_ENCOMENDA,
    payload: filtro
  }
}
